module.exports = __webpack_public_path__ + "img/SoftwareCopyright_3.7f1f8812.png";